import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import SelectAddOn from './SelectAddOn';
import AddOnService from '@spike/addon-service-model';
import { AlertNewBooking } from '../UI/AlertNewBooking';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

interface Props {
    selectedOption?: AddOnService;
    options: Array<AddOnService>;
    onSelectAddOn: (addOn: AddOnService) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            fontWeight: 600,
            fontSize: 16,
            lineHeight: '16px',
            marginBottom: 18,
            [theme.breakpoints.up('md')]: {
                marginBottom: 20
            }
        },
        alert: {
            marginBottom: '0px !important',
            height: 53
        },
        alertText: {
            fontSize: 14,
            lineHeight: '20px'
        }
    })
);

export const AddOnComponent: FunctionComponent<Props> = props => {
    const classes = useStyles();

    const emptyAddOnsComponent = (
        <Box id="booking_div_no_add_ons_alert">
            <AlertNewBooking
                className={classes.alert}
                bWidth="2px"
                icon={faExclamationTriangle}
                iconSize="lg"
                iconColor="#EAB464"
                bgColor="#F8F5F1"
                bdColor="#BCB8AE"
            >
                <Typography className={classes.alertText}>No add on available for this pet</Typography>
            </AlertNewBooking>
        </Box>
    );

    return (
        <>
            <Typography className={classes.title}>Add-On</Typography>
            {props.options?.length === 0 ? (
                emptyAddOnsComponent
            ) : (
                <SelectAddOn
                    placeholder="Select a Add-On"
                    selectedOption={props.selectedOption}
                    options={props.options}
                    onSelect={props.onSelectAddOn}
                />
            )}
        </>
    );
};

export default AddOnComponent;
